import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "./Logo";

export const SubpageHeader = ({ back = "/", backLabel = "Back to website", right = null, testId = "subpage-header" }) => (
  <header data-testid={testId} className="border-b border-white/10 bg-brand-navy">
    <div className="mx-auto flex max-w-[1200px] items-center justify-between px-6 py-4">
      <Link to="/" data-testid={`${testId}-logo`}><Logo dark testId={`${testId}-logo-mark`} /></Link>
      <div className="flex items-center gap-5">
        {right}
        <Link to={back} data-testid={`${testId}-back`} className="inline-flex items-center gap-2 text-sm text-white/70 transition hover:text-white"><ArrowLeft className="h-4 w-4" />{backLabel}</Link>
      </div>
    </div>
  </header>
);
